import { styled } from "@mui/material";
import { rateBuilderClasses } from "@sinch/components/application/RatelistBuilder/BuilderTree/components/RateBuilderTreeItemRoot";

interface RateBuilderNodeEnvelopeProps {
  dragged?: boolean;
}

/**
 * A styled wrapper component for rate builder tree nodes.
 * Handles styling including dragged state and connector lines.
 */
export const RateBuilderNodeEnvelope = styled("div", {
  shouldForwardProp: (prop) => prop !== "dragged",
})<RateBuilderNodeEnvelopeProps>(({ theme, dragged }) => ({
  ...(dragged && {
    outline: "2px dashed var(--lines-color)",
    outlineOffset: "-2px",
  }),
  borderRadius: `${theme.shape.borderRadius}px !important`,
  display: "flex",
  position: "relative",
  [`&.${rateBuilderClasses.entryRateContent}::before, li.${rateBuilderClasses.ifElseItem}:first-of-type &.${rateBuilderClasses.ifElseItemContent}::before`]:
    {
      content: `" "`,
      borderTop: "var(--tree-lines-width, 2px) solid var(--lines-color)",
      display: "block",
      height: "1px",
      width: `var(--main-line-offset)`,
      position: "absolute",
      top: "50%",
      left: "calc(-1 * var(--main-line-offset))",
    },
}));
